// can be used with vimeo-video.twig component and inline video element:
/*
VIMEO.TWIG COMPONENT:

<popup-video>
  {% include "components/vimeo-video.twig" with {
    site_images: site.theme.link ~ '/images',
    video_id: "1058970113/927774e05b",
    no_button: true
  }%}
</popup-video>

INLINE VIDEO ELEMENT:

<popup-video>
  <video
    class="object-cover w-full h-full block"
    playsinline
    controls
  >
    <source src="https://player.vimeo.com/progressive_redirect/download/1058970113/rendition/1080p/what_is_voluum%3F_a_complete_solution_for_media_buyers%21-usri6vbmlq%20%281080p%29.mp4?loc=external&signature=5a4dd876fa344612f1dd983d6ed5df3b02a294caf2d8923cd84c7651d19a46e2&user_id=205384705" type="video/mp4">
  </video>
</popup-video>
*/
export default class PopupVideo extends HTMLElement {
  constructor() {
    super();
    this.videoElement = this.querySelector("video");
    this.vimeoVideo = this.querySelector("vimeo-video");

  }

  connectedCallback() {
    if (!this.videoElement && !this.vimeoVideo){
      return;
    }

    this.addListeners();
  }

  addListeners() {
    document.addEventListener("newmodalopened", this.handleModalOpened.bind(this));
    document.addEventListener("newmodalclosed", this.handleModalClosed.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener("newmodalopened", this.handleModalOpened.bind(this));
    document.removeEventListener("newmodalclosed", this.handleModalClosed.bind(this));
  }

  handleModalOpened(event) {
    if (event.detail.modal === "what-video-modal") {
      if (this.vimeoVideo) {
        if (this.vimeoVideo.player) {
          this.vimeoVideo.player.play();
        }
      } else if (this.videoElement) {
        this.videoElement.play();
      }
    }
  }

  handleModalClosed(event) {
    if (event.detail.modal === "what-video-modal") {
      if (this.vimeoVideo) {
        if (this.vimeoVideo.player) {
          this.vimeoVideo.player.pause();
        }
      } else if (this.videoElement) {
        this.videoElement.pause();
      }
    }
  }
}
